import { useSlate } from 'slate-react'
import { RichTextAction } from '../../richTextEditor.constants'
import richTextEditorUtils from '../../richTextEditor.utils'
import { AlignKey, MarkKey } from '../../richTextEditor.types'
import IconBoldFont from '@/assets/icons/toolbar/iconBoldFont.svg?react'
import IconChangeColorFont from '@/assets/icons/toolbar/iconChangeColorFont.svg?react'
import IconItalicFont from '@/assets/icons/toolbar/iconItalicFont.svg?react'
import IconUnderlineFont from '@/assets/icons/toolbar/iconUnderlineFont.svg?react'
import IconAlignLeft from '@/assets/icons/toolbar/iconAlignLeft.svg?react'
import IconAlignCenter from '@/assets/icons/toolbar/iconAlignCenter.svg?react'
import IconAlignRight from '@/assets/icons/toolbar/iconAlignRight.svg?react'
import css from './toolbar.module.css'
import cn from './../../../../../../../utils/cn'
import { useEffect, useState } from 'react'
import ColorDropdown from '@/shared/Inputs/ColorDropdown'

const Toolbar = () => {
  const editor = useSlate()
  const [fontSize, setFontSize] = useState(14)
  const [color, setColor] = useState('black')

  useEffect(() => {
    // Обновить состояние при изменении выделения
    const currentFontSize = richTextEditorUtils.getCurrentFontSize(editor)

    setFontSize(currentFontSize)
  }, [editor.selection])

  const handleMarkClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>, id: RichTextAction) => {
    e.preventDefault()
    richTextEditorUtils.toggleMark(editor, id as MarkKey)
  }

  const handleAlignClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>, id: RichTextAction) => {
    e.preventDefault()
    richTextEditorUtils.toggleTextAlign(editor, id as AlignKey)
  }

  const getMarkSelectionProps = (id: RichTextAction) => {
    return richTextEditorUtils.isMarkActive(editor, id as MarkKey)
  }
  const getTextAlignSelectionProps = (id: RichTextAction) => {
    return richTextEditorUtils.isActiveTextAlign(editor, id as AlignKey)
  }

  const handleFontSize = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>, increment: number) => {
    e.preventDefault()
    setFontSize((prev) => {
      const newSize = prev + increment
      if (newSize >= 4 && newSize <= 50) {
        // Ограничение по размеру шрифта
        richTextEditorUtils.toggleFontSize(editor, newSize)
        return newSize
      }
      return prev
    })
  }

  const handleTextColor = (color: string) => {
    setColor(color)
    richTextEditorUtils.toggleTextColor(editor, color)
  }

  const renderButton = (icon: JSX.Element, action: RichTextAction, isAlignButton = false) => {
    const handleActive = isAlignButton ? getTextAlignSelectionProps(action) : getMarkSelectionProps(action)

    const handleClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
      return isAlignButton ? handleAlignClick(e, action) : handleMarkClick(e, action)
    }
    return (
      <div className={css.settingWrapper} data-active={handleActive} onMouseDown={handleClick}>
        {icon}
      </div>
    )
  }

  return (
    <div className={css.wrapper}>
      <div className={css.editFontSize}>
        <button className={css.settingWrapper} onMouseDown={(e) => handleFontSize(e, -1)}>
          -
        </button>
        <div className={cn('text-nm', css.valueFontSize)}>{fontSize}</div>
        <button className={css.settingWrapper} onMouseDown={(e) => handleFontSize(e, 1)}>
          +
        </button>
      </div>
      <VerticalLine />
      {renderButton(<IconBoldFont />, RichTextAction.Bold)}
      {renderButton(<IconItalicFont />, RichTextAction.Italics)}
      {renderButton(<IconUnderlineFont />, RichTextAction.Underline)}
      <ColorDropdown
        value={color}
        name="color"
        onChange={handleTextColor}
        icon={
          <div className={css.settingWrapper}>
            <IconChangeColorFont />
          </div>
        }
      />
      <VerticalLine />
      {renderButton(<IconAlignLeft />, RichTextAction.LeftAlign, true)}
      {renderButton(<IconAlignCenter />, RichTextAction.CenterAlign, true)}
      {renderButton(<IconAlignRight />, RichTextAction.RightAlign, true)}
    </div>
  )
}

export default Toolbar

const VerticalLine = () => {
  return <div className={css.verticalLine} />
}
